import { render, staticRenderFns } from "./ProofHistory.vue?vue&type=template&id=4047e7ba"
import script from "./ProofHistory.vue?vue&type=script&lang=js"
export * from "./ProofHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports